import { render, staticRenderFns } from "./ShunyiAuthPage.vue?vue&type=template&id=51687df7&scoped=true"
import script from "./ShunyiAuthPage.vue?vue&type=script&lang=js"
export * from "./ShunyiAuthPage.vue?vue&type=script&lang=js"
import style0 from "./ShunyiAuthPage.vue?vue&type=style&index=0&id=51687df7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51687df7",
  null
  
)

export default component.exports